import s from './GeneratingState.module.css'

export const GeneratingState = () => {
  return (
    <div className={s.wrapper}>
      <div className={s.illustration}></div>
      <div className={s.message}></div>
      <div className={s.hint}>Data syncing usually takes 1 hour.</div>
    </div>
  )
}
